var React = require('react');

function LongArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeMiterlimit":"10","d":"M1.681 7.817h71.576","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"M67.235 1.351l6.75 6.466-6.75 7.499","key":1})]);
}

LongArrow.defaultProps = {"viewBox":"0 0 75.417 16.667"};

module.exports = LongArrow;

LongArrow.default = LongArrow;
